import { render, staticRenderFns } from "./Particles.vue?vue&type=template&id=70a494e1&scoped=true&"
import script from "./Particles.vue?vue&type=script&lang=js&"
export * from "./Particles.vue?vue&type=script&lang=js&"
import style0 from "./Particles.vue?vue&type=style&index=0&id=70a494e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a494e1",
  null
  
)

export default component.exports